import { AlertTriangle, Phone, Heart, Droplet, Thermometer, Bandage } from 'lucide-react';
import { Link } from 'react-router-dom';
import './FirstAidGuidePage.css';

export default function FirstAidGuidePage() {
  return (
    <div className="first-aid-page">
      <div className="first-aid-header">
        <h1>🏥 Erste-Hilfe Guide</h1>
        <p>Wichtige Notfall-Informationen für unterwegs</p>
        <div className="emergency-numbers">
          <div className="emergency-card">
            <Phone size={32} color="#ef4444" />
            <div>
              <div className="number">112</div>
              <div className="label">Notruf EU</div>
            </div>
          </div>
          <div className="emergency-card">
            <Phone size={32} color="#ef4444" />
            <div>
              <div className="number">999</div>
              <div className="label">Notruf UK</div>
            </div>
          </div>
        </div>
      </div>

      <div className="first-aid-content">
        <section className="aid-section">
          <h2><AlertTriangle size={24} /> Sturz / Verletzungen</h2>
          <div className="steps">
            <div className="step">
              <span className="step-num">1</span>
              <div>
                <strong>Ruhe bewahren</strong>
                <p>Ersthelfer rufen, Verletzten nicht bewegen</p>
              </div>
            </div>
            <div className="step">
              <span className="step-num">2</span>
              <div>
                <strong>Atmung prüfen</strong>
                <p>Atemwege freihalten, stabile Seitenlage wenn nötig</p>
              </div>
            </div>
            <div className="step">
              <span className="step-num">3</span>
              <div>
                <strong>Notruf 112/999</strong>
                <p>Standort, Anzahl Verletzter, Art der Verletzung</p>
              </div>
            </div>
            <div className="step">
              <span className="step-num">4</span>
              <div>
                <strong>Blutung stillen</strong>
                <p>Druckverband anlegen, Wunde bedecken</p>
              </div>
            </div>
          </div>
        </section>

        <section className="aid-section">
          <h2><Bandage size={24} /> Schürfwunden / Schnitte</h2>
          <ul className="aid-list">
            <li>✓ Wunde mit sauberem Wasser ausspülen</li>
            <li>✓ Desinfizieren (wenn vorhanden)</li>
            <li>✓ Mit sterilem Verband abdecken</li>
            <li>✓ Bei tiefen Schnitten: Druckverband + Notruf</li>
          </ul>
        </section>

        <section className="aid-section">
          <h2><Thermometer size={24} /> Unterkühlung / Erschöpfung</h2>
          <ul className="aid-list">
            <li>⚠️ Symptome: Zittern, Verwirrtheit, verlangsamte Sprache</li>
            <li>✓ Betroffenen aus Wind/Regen bringen</li>
            <li>✓ Nasse Kleidung ausziehen</li>
            <li>✓ In trockene Decke/Schlafsack wickeln</li>
            <li>✓ Warme (nicht heiße!) Getränke geben</li>
            <li>⚠️ Bei Bewusstlosigkeit: 112/999 sofort!</li>
          </ul>
        </section>

        <section className="aid-section">
          <h2><Droplet size={24} /> Dehydrierung</h2>
          <ul className="aid-list">
            <li>⚠️ Symptome: Kopfschmerzen, Schwindel, dunkler Urin</li>
            <li>✓ Langsam Wasser trinken (nicht zu schnell!)</li>
            <li>✓ Elektrolyte wenn vorhanden (Salz + Zucker)</li>
            <li>✓ Im Schatten ausruhen</li>
            <li>✓ Pro Stunde: Mind. 0.5L Wasser</li>
          </ul>
        </section>

        <section className="aid-section warning">
          <h2><Heart size={24} /> Herzinfarkt / Schlaganfall</h2>
          <div className="critical-warning">
            <AlertTriangle size={32} />
            <div>
              <strong>SOFORT 112/999 RUFEN!</strong>
              <p>Symptome: Brustschmerzen, Atemnot, Lähmung, Sprachstörung</p>
            </div>
          </div>
          <ul className="aid-list">
            <li>✓ Person hinsetzen/hinlegen</li>
            <li>✓ Enge Kleidung lösen</li>
            <li>✓ Bei Bewusstlosigkeit: Stabile Seitenlage</li>
            <li>✓ Wiederbelebung wenn keine Atmung!</li>
          </ul>
        </section>

        <section className="aid-section kit">
          <h2>🎒 Erste-Hilfe Set Checkliste</h2>
          <div className="kit-grid">
            <div className="kit-item">✓ Sterile Kompressen</div>
            <div className="kit-item">✓ Pflaster (verschiedene Größen)</div>
            <div className="kit-item">✓ Elastische Binden</div>
            <div className="kit-item">✓ Dreieckstuch</div>
            <div className="kit-item">✓ Desinfektionsmittel</div>
            <div className="kit-item">✓ Schmerzmittel</div>
            <div className="kit-item">✓ Blasenpflaster</div>
            <div className="kit-item">✓ Zeckenzange</div>
            <div className="kit-item">✓ Rettungsdecke</div>
            <div className="kit-item">✓ Einmalhandschuhe</div>
          </div>
        </section>

        <div className="aid-disclaimer">
          <AlertTriangle size={20} />
          <p>Dieser Guide ersetzt keine professionelle medizinische Ausbildung. Bei Notfällen immer 112/999 rufen!</p>
        </div>

        <Link to="/" className="btn-back">
          ← Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
